import { Storybook } from "@tento-ui/ui/storybook";
import { DshTurnAsk } from "./ask";

export class DshTurnAskStoryBook extends Storybook.Default {
  title(): string {
    return "Turn dsh · ask";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Pending — the warn tone, on the glyph and nowhere else",
        render: () =>
          DshTurnAsk.makeWith({
            title: "Run the pane-runtime test suite?",
            command: "cargo test -q -p tento-pane-runtime",
            options: [
              { optionId: "allow_once", name: "Allow once", kind: "allow_once" },
              { optionId: "allow_always", name: "Allow always", kind: "allow_always" },
              { optionId: "reject_once", name: "Reject", kind: "reject_once" },
            ],
            state: "pending",
          }),
      },
      {
        title: "Pending, wired — the option lines answer",
        render: () =>
          DshTurnAsk.makeWith({
            title: "Apply the fix to closeTurn and re-run?",
            command: "cargo test -q -p tento-pane-runtime dispatch::",
            options: [
              { optionId: "allow_once", name: "Allow once", kind: "allow_once" },
              { optionId: "reject_once", name: "Reject", kind: "reject_once" },
            ],
            state: "pending",
            onOption: () => {},
          }),
      },
      {
        title: "Decided — the taken option, as a dim suffix",
        render: () =>
          DshTurnAsk.makeWith({
            title: "Run the pane-runtime test suite?",
            command: "cargo test -q -p tento-pane-runtime",
            options: [
              { optionId: "allow_once", name: "Allow once", kind: "allow_once" },
              { optionId: "allow_always", name: "Allow always", kind: "allow_always" },
              { optionId: "reject_once", name: "Reject", kind: "reject_once" },
            ],
            state: "decided",
            decidedOptionId: "allow_once",
          }),
      },
      {
        title: "Decided, answer not kept — the question alone",
        render: () =>
          DshTurnAsk.makeWith({
            title: "Edit index.root.ts",
            options: [
              { optionId: "allow", name: "Allow", kind: "allow_once" },
              { optionId: "reject", name: "Reject", kind: "reject_once" },
            ],
            state: "decided",
          }),
      },
      {
        title: "No command — the body is options only",
        render: () =>
          DshTurnAsk.makeWith({
            title: "Edit tento-pane-runtime/src/dispatch.rs",
            options: [
              { optionId: "allow", name: "Allow", kind: "allow_once" },
              { optionId: "reject", name: "Reject", kind: "reject_once" },
            ],
            state: "pending",
          }),
      },
      {
        title: "A long question — the subject ellipsises, the row stays 24px",
        render: () =>
          DshTurnAsk.makeWith({
            title:
              "Allow writing to /Users/james/workspace/tento/tento-node-registry/tento-spool.node/html/routes/stream-items.ts and re-running the deno build?",
            command: "deno run -A build.deno.ts",
            options: [
              { optionId: "allow", name: "Allow", kind: "allow_once" },
              { optionId: "reject", name: "Reject", kind: "reject_once" },
            ],
            state: "pending",
          }),
      },
    ];
  }
}
